<article>
    <header>
        <kal-icon *ngIf="isCloseButtonDisplayed"
                  (click)="close()"
                  class="gup-C-buttonClose">
            close
        </kal-icon>
    </header>

    <div class="main" [appProgressOverlay]="['report']">
        <canvas
            #canvas
            (mousedown)="handleMouseDown($event)"
            (mouseup)="handleMouseUp($event)"
            (dblclick)="zoom()"
            (mouseleave)="handleMouseLeave($event)"
            (mousemove)="handleMouseMove($event)">
        </canvas>
    </div>

    <footer>
        <div class="gup-C-viewerdoc">

            <div *ngIf="isMultipage" class="gup-C-viewerdoc__nav">
                <kal-icon [class.disabled]="!hasPreviousPage"
                          (click)="firstPage()">first_page
                </kal-icon>
                <kal-icon [class.disabled]="!hasPreviousPage"
                          (click)="previousPage()">chevron_left
                </kal-icon>

                <div class="gup-C-viewerdoc__nbPage">{{currentPage}}/{{totalPages}}</div>

                <kal-icon [class.disabled]="!hasNextPage"
                          (click)="nextPage()">chevron_right
                </kal-icon>
                <kal-icon [class.disabled]="!hasNextPage"
                          (click)="lastPage()">last_page
                </kal-icon>
            </div>
            <div class="gup-C-viewerdoc__zoom">
                <kal-icon (click)="zoom()">zoom_in</kal-icon>
                <kal-icon (click)="dezoom()">zoom_out</kal-icon>
            </div>
        </div>

        <div class="gup-C-validationArea gup-O-list">

            <div class="gup-O-list__item">
                <kal-button kalTheme="primary" [disabled]="loading" (click)="printAction()">Imprimer</kal-button>
            </div>

            <div *ngIf="!hideExportButton" class="gup-O-list__item">
                <a [href]="pdfUrl | sanitize:'url'" [download]="getFilename('pdf')">
                    <kal-button kalTheme="secondary" [disabled]="loading">PDF</kal-button>
                </a>
            </div>

            <div *ngIf="!hideExportButton" class="gup-O-list__item">
                <a [href]="xlsUrl | sanitize:'url'" [download]="getFilename('xls')">
                    <kal-button kalTheme="secondary" [disabled]="loading">XLS</kal-button>
                </a>
            </div>

            <div class="gup-O-list__item" *ngIf="!isCloseButtonDisplayed">
                <kal-button kalTheme="tertiary" (click)="close()">Fermer</kal-button>
            </div>
        </div>
    </footer>

</article>
